import {
    CustomStudyTheme1
} from './customStudyTheme1/index';

const customStudyThemeList = [CustomStudyTheme1];

export {
    customStudyThemeList
}
